import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  customTool: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginTop: '10px'
  },
  dialogTitle: {
    lineHeight: '2 !important',
    padding: '8px 10px !important',
  },
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      '& .makeStyles-dialogTitle-37': {
        padding: '16px 12px !important',
      },
      maxWidth: '1300px'
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  disableIcon: {
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  invalidRow: {
    backgroundColor: '#ffcccc !important'
  }
}));
export default styles;
